import { useState } from 'react';
import { Link } from 'react-router-dom';
import { BarChart2, Users, FileText, CreditCard, Layout, Newspaper, Home, BookOpen, Bell } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import Dashboard   from './Dashboard';
import UsersTab    from './Users';
import DocumentsTab from './Documents';
import PaymentsTab from './Payments';
import PagesTab    from './PagesTab';
import BlogManager from './BlogManager';

const TABS = [
  ['dashboard',  <BarChart2 size={15}/>,  'Dashboard'],
  ['users',      <Users size={15}/>,      'Users'],
  ['documents',  <FileText size={15}/>,   'Documents'],
  ['payments',   <CreditCard size={15}/>, 'Payments'],
  ['pages',      <Layout size={15}/>,     'Pages / CMS'],
  ['blog',       <Newspaper size={15}/>,  'Blog Manager'],
];

export default function Admin() {
  const { user } = useAuth();
  const [tab, setTab] = useState('dashboard');

  const switchTab = t => setTab(t);

  const TAB_LABELS = { dashboard:'Dashboard Overview', users:'User Management', documents:'Documents', payments:'Payments', pages:'Pages & CMS', blog:'Blog Manager' };

  return (
    <div className="flex min-h-screen bg-gray-50">
      {/* Sidebar */}
      <div className="w-52 bg-blue-950 text-white flex flex-col py-5 px-3 shrink-0 sticky top-0 h-screen overflow-y-auto">
        <div className="flex items-center gap-2 mb-6 px-2">
          <div className="w-7 h-7 bg-yellow-500 rounded-lg flex items-center justify-center"><BookOpen size={13} className="text-blue-950"/></div>
          <span className="font-bold text-sm">LawOC Admin</span>
        </div>
        {TABS.map(([id,icon,label])=>(
          <button key={id} onClick={()=>switchTab(id)}
            className={"flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm mb-1 transition text-left "+(tab===id?'bg-yellow-500 text-blue-950 font-semibold':'text-blue-300 hover:bg-blue-900')}>
            {icon}{label}
          </button>
        ))}
        <div className="mt-auto pt-4 border-t border-blue-900">
          <div className="px-3 py-2 text-xs text-blue-400">Logged in as</div>
          <div className="px-3 py-1 text-sm text-blue-200 font-medium truncate">{user?.name}</div>
          <Link to="/" className="flex items-center gap-2 px-3 py-2 text-blue-400 hover:text-white text-sm mt-1 transition"><Home size={14}/>Back to Site</Link>
        </div>
      </div>

      {/* Main content */}
      <div className="flex-1 overflow-auto">
        <div className="bg-white border-b px-6 py-3 flex items-center justify-between sticky top-0 z-10">
          <h2 className="font-bold text-gray-700">{TAB_LABELS[tab]||tab}</h2>
          <div className="flex items-center gap-3">
            <Bell size={16} className="text-gray-400"/>
            <span className="bg-blue-950 text-white px-3 py-1 rounded-lg text-xs font-bold">🛡️ Admin</span>
          </div>
        </div>
        <div className="p-6">
          {tab==='dashboard'  && <Dashboard/>}
          {tab==='users'      && <UsersTab/>}
          {tab==='documents'  && <DocumentsTab/>}
          {tab==='payments'   && <PaymentsTab/>}
          {tab==='pages'      && <PagesTab/>}
          {tab==='blog'       && <BlogManager/>}
        </div>
      </div>
    </div>
  );
}
